// 首页 与 知心 推荐车部分代码
/* istanbul ignore next */
define('widget/recommend-car-list', ['jquery', 'log', 'log-search', 'jquery.lazyload'], ($, log, searchLog) => {
    function carListInit() {
        // init lazyload for all car image
        const ndCarMore = $('#js-car-more');
        $('.car-list-box .img-lazy').lazyload({
            data_attribute: 'src',
            skip_invisible: false,
        });
        ndCarMore.attr('href', $('.car-list-title ul li:first').parent('a').attr('href'));
        // attach event handler
        $('.car-list-title ul li').on('mouseenter', function () {
            const ndItem = $(this);
            if (ndItem.hasClass('lastli')) {
                return;
            }
            $('.car-list-title ul li').removeClass('selected');
            ndItem.addClass('selected');

            const moreHref = ndItem.parent('a').attr('href');
            const position = ndItem.data('more_position');

            ndCarMore.attr('href', moreHref);
            ndCarMore.attr('rrc-event-expand-position', position);
            if (($(`#${ndItem.data('value')}`).css('display')) !== 'block') {
                log.push(['_trackEvent', `pc-index-carlist-${$(this).parent().attr('rrc-event-name')}-hover`, 'mouseenter']);
                $('.car-list-box .list').hide();
                $(`#${ndItem.data('value')}`).show().find('.img-lazy').trigger('appear');
            }

            const carList = $(`#${ndItem.data('value')}`).find('a');
            const carIdArr = $.map(carList, function (item) { // eslint-disable-line
                return (item.getAttribute('data-car-id'));
            });
            if (ndItem.attr('js-one-enter') !== '1') {
                log.push(['_trackEvent', 'home_hot_tags_list', {
                    carListTitle: ndItem[0].innerText,
                    isDefault: false,
                    carIds: carIdArr,
                }]);
                ndItem.attr('js-one-enter', 1);
            }
        });

        // active first
        $('.car-list-title ul li:first').addClass('selected');
        $('.car-list-box .list:first').show().find('.img-lazy').trigger('appear');

        // 热门分类(默认展示)标签统计
        searchLog.register({
            eventName: 'home_hot_tags_list',
            container: $('#car_source_module_one'),
            eventProperty: {
                carListTitle: '特价好车',
                isDefault: true,
            },
        });
    }

    function init() {
        carListInit();
    }

    return {
        init,
    };
});
/* istanbul ignore if */
if (typeof window.__karma__ === 'undefined') {
    require(['widget/recommend-car-list'], (page) => {
        page.init();
    });
}
